import React, {Component} from 'react';
import styles from './EnhancedCard.module.css';
import DefaultProfileImg from '../../../../shared/project-info/images/DefaultProfileImg.png';
import moment from 'moment';
import {
  defaultEventPhoto,
  localizeDate,
} from '../../../../shared/utils/Helpers';
import {Link} from 'react-router-dom';
import {DATE_FMT, TIME_FMT} from '../../../../shared/constants/DateFormats';
import {formatEventCardTitle} from '../../../../shared/utils/FeedHelpers';
import {projectConfig} from '../../../../shared/project-info/projectConfig';

export default class EnhancedCard extends Component {
  render() {
    const {
      id,
      name,
      category,
      start,
      end,
      photo_url,
      time_zone_id,
      group_name,
      is_all_day,
      is_virtual,
    } = this.props.event;
    let startTime = localizeDate(time_zone_id, start);
    let endTime = localizeDate(time_zone_id, end);
    return (
      <Link to={`/events/${id}`}>
        <div className={styles.container}>
          <div className={styles.imageContainer}>
            {(photo_url || projectConfig.defaultEventImages) && (
              <img
                className={styles.cardImage}
                src={photo_url || defaultEventPhoto(category, name)}
                alt="Event Image"
              />
            )}
          </div>
          <div className={styles.cardInfoContainer}>
            <p className={styles.eventTitle}>{formatEventCardTitle(name)}</p>
            {/* not yet added */}
            <p className={styles.groupName}>{group_name}</p>
            <p className={styles.dateInfo}>
              {localizeDate(time_zone_id, startTime).format(DATE_FMT)}
            </p>
            <p className={styles.dateInfo}>
              {is_all_day
                ? 'All Day Event'
                : `${localizeDate(time_zone_id, startTime).format(
                    TIME_FMT,
                  )} - ${localizeDate(time_zone_id, endTime).format(TIME_FMT)}`}
            </p>
          </div>
        </div>
      </Link>
    );
  }
}
